import { countryOptions, mxStates } from "../../utils/constants/countryOptions";

const AddressTable = ({ label, address }) => {
  if (!address || !address.State) return null;

  const street = address.Street || `${address.Line1 || ''} ${address.Line2 || ''}`;
  const state = countryOptions.US.find(id => id.code === address.State)?.label
  ?? countryOptions.CA.find(id => id.code === address.State)?.label
  ?? mxStates.find(id => id.code === address.State)?.label
  ?? address.State
  console.log('updated state', state);
  return (
    <>
      <th>{label}</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Street</th><th>City</th><th>County</th><th>State</th><th>Zip code</th><th>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{street}</td>
            <td>{address.City}</td>
            <td>{address.County || ''}</td>
            <td>{state}</td>
            <td>{address.Zip}</td>
            <td>{address.Country || ''}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default AddressTable;
